import React, { useRef, useState } from "react";
import { Globe, FileText, Upload, Trash2, Eye } from "lucide-react";
import ExtractedPreviewDialog from "./ExtractedPreviewDialog";

export default function TrainingColumn({
  urlValue, setUrlValue, crawlSite, setCrawlSite, onAddUrl,
  textName, setTextName, textBody, setTextBody, onAddText,
  onUploadFile, sources, onRemoveSource,
}) {
  const fileRef = useRef(null);
  const handleUpload = () => onUploadFile(fileRef);
  const [previewSourceId, setPreviewSourceId] = useState(null);

  return (
    <div className="space-y-4" data-testid="builder-col-training">
      <div className="flex items-center gap-2 pb-2 border-b-2 border-[#030712]">
        <div className="font-display font-extrabold text-lg uppercase tracking-tight">Training</div>
        <div className="text-[10px] font-mono text-[#4B5563]">your agent&apos;s brain</div>
      </div>

      <div className="hs-card p-4">
        <div className="font-display font-bold text-sm flex items-center gap-2"><Globe className="w-4 h-4" /> Train from URL</div>
        <div className="text-[11px] text-[#4B5563] mt-1">Renders JS sites too (React, Next.js, Vue).</div>
        <div className="flex gap-2 mt-3">
          <input data-testid="kb-url-input" value={urlValue} onChange={(e) => setUrlValue(e.target.value)} placeholder="https://your-site.com" className="flex-1 border border-[#E2E8F0] px-2 py-2 rounded-sm text-xs" />
          <button onClick={onAddUrl} className="btn-primary text-xs" data-testid="kb-url-add-button">Add</button>
        </div>
        <label className="flex items-center gap-2 mt-3 text-xs cursor-pointer">
          <input type="checkbox" data-testid="kb-url-crawl-site" checked={crawlSite} onChange={(e) => setCrawlSite(e.target.checked)} />
          <span>Crawl whole site (sitemap, up to 8 pages)</span>
        </label>
      </div>

      <div className="hs-card p-4">
        <div className="font-display font-bold text-sm flex items-center gap-2"><FileText className="w-4 h-4" /> Paste text</div>
        <input data-testid="kb-text-name-input" value={textName} onChange={(e) => setTextName(e.target.value)} placeholder="Name (e.g. FAQ)" className="w-full border border-[#E2E8F0] px-2 py-2 rounded-sm text-xs mt-3" />
        <textarea data-testid="kb-text-body-input" rows={3} value={textBody} onChange={(e) => setTextBody(e.target.value)} placeholder="Your text…" className="w-full border border-[#E2E8F0] px-2 py-2 rounded-sm text-xs mt-2 font-mono" />
        <button onClick={onAddText} className="btn-primary text-xs w-full mt-2" data-testid="kb-text-add-button">Embed</button>
      </div>

      <div className="hs-card p-4">
        <div className="font-display font-bold text-sm flex items-center gap-2"><Upload className="w-4 h-4" /> Upload file</div>
        <div className="text-[11px] text-[#4B5563] mt-1">PDF, DOCX, XLSX, TXT, CSV, MD</div>
        <input data-testid="kb-file-input" type="file" ref={fileRef} accept=".pdf,.docx,.xlsx,.txt,.csv,.md" className="w-full text-xs mt-3" />
        <button onClick={handleUpload} className="btn-primary text-xs w-full mt-2" data-testid="kb-file-upload-button">Upload & train</button>
      </div>

      <div className="hs-card p-4">
        <div className="font-display font-bold text-sm">Sources ({sources.length})</div>
        <div className="text-[10px] font-mono text-[#4B5563] mt-1">shared across all channels</div>
        <div className="space-y-2 mt-3 max-h-80 overflow-auto">
          {sources.length === 0 && <div className="text-xs text-[#4B5563]">No sources yet.</div>}
          {sources.map((s) => (
            <div key={s.id} className="flex items-start justify-between gap-2 text-xs border-b border-[#E2E8F0] pb-2" data-testid={`source-row-${s.id}`}>
              <div className="min-w-0">
                <div className="truncate font-medium">{s.name}</div>
                <div className="text-[#4B5563] font-mono">{s.type} · {s.chunks} chunks</div>
              </div>
              <div className="flex items-center gap-1 shrink-0">
                <button onClick={() => setPreviewSourceId(s.id)} className="text-[#0044FF] hover:bg-[#0044FF]/10 p-1" title="View extracted content" data-testid={`source-preview-${s.id}`}><Eye className="w-3 h-3" /></button>
                <button onClick={() => onRemoveSource(s.id)} className="text-[#EF4444] hover:bg-[#EF4444]/10 p-1" data-testid={`source-delete-${s.id}`}><Trash2 className="w-3 h-3" /></button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <ExtractedPreviewDialog
        open={!!previewSourceId}
        sourceId={previewSourceId}
        onClose={() => setPreviewSourceId(null)}
      />
    </div>
  );
}
